import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateStatus = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateStatus.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
